<template>
    <div class="bg-white p-3">
      <table class="table table-bordered table-sm">
        <thead class="thead-light">
          <tr>
            <th>Désignation</th>
            <th>Quantité</th>
            <th>Prix unitaire</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input type="text" class="form-control"
                v-model="libelleLocal"
              />
            </td>
            <td class="col-qte">
              <input type="number" min="1" class="form-control"
                v-model.number="qteLocal"
              />
            </td>
            <td>{{ montantUnitaire.toFixed(0) }}</td>
            <td>{{ montantTotal.toFixed(0) }}</td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-primary btn-sm" @click="mettreAJour" :disabled="isLoading">
        Mettre à jour
        <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "InvoiceEditorReservation",
    props: {
      libelle: {
        type: String,
        required: true
      },
      qte: {
        type: Number,
        required: true
      },
      montant: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        libelleLocal: this.libelle,
        qteLocal: this.qte
      }
    },
    computed: {
      montantUnitaire() {
        return this.montant / this.qte;
      },
      montantTotal() {
        return this.montantUnitaire * this.qteLocal;
      }
    },
    methods: {
      mettreAJour() {
        this.$emit("update-ligne", {
          libelle: this.libelleLocal,
          qte: this.qteLocal,
          price: this.montantUnitaire,
          totalPrice: this.montantTotal
        });
      }
    }
  }
  </script>
  
  <style scoped>
.col-qte {
  width: 80px; /* Ajuste la largeur à ton goût */
}
.col-qte input {
  padding: 0.25rem; /* Pour éviter que ça déborde */
  text-align: center;
}

</style>